import {Record} from 'immutable/dist/immutable';

export default Record({
  rank: undefined,
  outOf: undefined,
  value: undefined,
});
